import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { vendorsApi } from "@/lib/api";
import { useToast } from "@/components/SimpleToast";
import { apiError } from "./vendorUtils";
import { VendorFields } from "./VendorFields";

const EMPTY = { name: "", website: "", category: "", description: "", status: "active" };

export function VendorFormDialog({ open, onOpenChange, onCreated }) {
  const toast = useToast();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error("Bitte einen Namen eingeben");
    setSaving(true);
    try {
      const res = await vendorsApi.create(form);
      toast.success(res.data.has_logo ? "Hersteller angelegt – Logo gefunden" : "Hersteller angelegt – kein Logo gefunden");
      setForm(EMPTY);
      onCreated(res.data);
    } catch (err) {
      toast.error(apiError(err, "Hersteller konnte nicht angelegt werden"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="vendor-create-dialog">
        <DialogHeader>
          <DialogTitle>Hersteller hinzufügen</DialogTitle>
          <DialogDescription>Das Logo wird anhand der Website automatisch gesucht.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <VendorFields form={form} setForm={setForm} prefix="create" />
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
            <Button type="submit" disabled={saving} data-testid="vendor-create-submit">
              {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              {saving ? "Logo wird gesucht…" : "Anlegen"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
